<template>
  <div class="col-12 d-flex justify-content-around align-items-center py-15">
    <button
      class="btn btn-square btn-lg btn-primary rounded-circle mx-10"
      role="button"
      @click="reload"
    >
      <svg
        class="w-6 h-6 m-10"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        ></path>
      </svg>
    </button>
    <button
      class="btn btn-rounded btn-sm btn-success poke-font-gb-regular"
      type="button"
    >
      &nbsp;&nbsp;&nbsp;
    </button>
    <button
      class="btn btn-rounded btn-sm btn-secondary poke-font-gb-regular"
      type="button"
    >
      &nbsp;&nbsp;&nbsp;
    </button>
  </div>
  <div class="row bg-danger ml-5 mb-20 pr-5">
    <div class="col-8">
      <div class="row card bg-secondary poke-font-gb-regular">
        <div class="col-12 my-10 font-weight-semi-bold">
          ¿Quién es este Pokémon?
        </div>
        <div v-if="!reloading" class="col-12">
          <div v-if="!showPokemon">
            <div
              v-for="pokemon in pokemons"
              :key="pokemon.id"
              @click="choosePokemon(pokemon.id)"
              class="col-12 pokemon mb-5"
            >
              {{ pokemon.name.toUpperCase() }}
            </div>
          </div>
          <div v-else class="col-12">
            <div class="col-12 mb-5">&nbsp;</div>
            <div class="col-12 mb-5">{{ message }}</div>
            <div class="col-12 mb-5">&nbsp;</div>
            <div class="col-12 mb-5">&nbsp;</div>
          </div>
        </div>
        <div v-else class="col-12">
          <div class="col-12 mb-5">&nbsp;</div>
          <div class="col-12 mb-5">cargando...</div>
          <div class="col-12 mb-5">&nbsp;</div>
          <div class="col-12 mb-5">&nbsp;</div>
        </div>
      </div>
    </div>
    <div class="col-4 d-flex align-items-center">
      <div class="row">
        <div class="col-12">
          <span class="btn btn-square btn-primary rounded-circle">
            <svg
              class="w-6 h-6 m-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 15l7-7 7 7"
              ></path>
            </svg>
          </span>
        </div>
        <div
          class="col-12 d-flex justify-content-center align-items-center mb-5 mt-lg-5 mb-lg-10"
        >
          <span class="btn btn-square btn-primary rounded-circle">
            <svg
              class="w-6 h-6 m-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              ></path>
            </svg>
          </span>
          <span
            v-if="!showPokemon"
            class="btn btn-square btn-lg btn-primary rounded-circle mx-5 mx-lg-10"
          >
            <svg
              class="w-6 h-6 m-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              ></path>
            </svg>
          </span>
          <button
            v-else
            class="btn btn-square btn-lg btn-primary rounded-circle mx-10"
            role="button"
            @click="reload"
          >
            <svg
              class="w-6 h-6 m-10"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              ></path>
            </svg>
          </button>
          <span class="btn btn-square btn-primary rounded-circle">
            <svg
              class="w-6 h-6 m-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              ></path>
            </svg>
          </span>
        </div>
        <div class="col-12">
          <span class="btn btn-square btn-primary rounded-circle">
            <svg
              class="w-6 h-6 m-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PokemonOptions',
  emits: {
    reload: null,
    selection: null,
  },
  props: {
    pokemons: {
      type: Array,
      required: true,
    },
    canChoose: {
      type: Boolean,
      required: true,
      default: true,
    },
    message: {
      type: String,
      required: true,
      default: '',
    },
    reloading: {
      type: Boolean,
      required: true,
      default: false,
    },
    showPokemon: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    choosePokemon(pokemonId) {
      if (!this.canChoose) {
        return
      }
      this.$emit('selection', pokemonId)
    },
    reload() {
      this.$emit('reload')
    },
  },
}
</script>

<style scoped lang="scss">
.pokemon:hover {
  color: #fff;
  background-color: var(--primary-color);
  cursor: pointer;
}
.hand {
  cursor: pointer;
}
</style>
